var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14209 16.1619C3.30626 17.7334 4.63509 18.9584 6.25003 18.9584H14.1667C16.1227 18.9584 17.7084 17.3727 17.7084 15.4167V11.095C17.7056 11.8103 17.6259 12.5232 17.4708 13.2216C17.0505 15.1128 15.373 16.4584 13.4357 16.4584H4.19256C3.79984 16.4584 3.44249 16.3485 3.14209 16.1619Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78782 2.2915C6.70969 2.48451 6.66667 2.69548 6.66667 2.9165C6.66667 3.83698 7.41286 4.58317 8.33333 4.58317H12.5C13.4205 4.58317 14.1667 3.83698 14.1667 2.9165C14.1667 2.69548 14.1236 2.48451 14.0455 2.2915H14.1669C16.123 2.2915 17.7086 3.87716 17.7086 5.83317V11.0561C17.7086 11.7844 17.6289 12.5104 17.4709 13.2213C17.0507 15.1126 15.3732 16.4582 13.4358 16.4582H4.19273C2.74856 16.4582 1.78254 14.9717 2.36907 13.652C2.86766 12.5302 3.12528 11.3162 3.12528 10.0886V5.83317C3.12528 3.87716 4.71094 2.2915 6.66694 2.2915H6.78782Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 1.25C7.41286 1.25 6.66667 1.99619 6.66667 2.91667C6.66667 3.83714 7.41286 4.58333 8.33333 4.58333H12.5C13.4205 4.58333 14.1667 3.83714 14.1667 2.91667C14.1667 1.99619 13.4205 1.25 12.5 1.25H8.33333Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29167 11.4583C7.29167 11.1131 7.57149 10.8333 7.91667 10.8333H12.9167C13.2618 10.8333 13.5417 11.1131 13.5417 11.4583C13.5417 11.8034 13.2618 12.0833 12.9167 12.0833H7.91667C7.57149 12.0833 7.29167 11.8034 7.29167 11.4583Z",
    fill: "#252525"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29167 8.54175C7.29167 8.19657 7.57149 7.91675 7.91667 7.91675H10C10.3452 7.91675 10.625 8.19657 10.625 8.54175C10.625 8.88693 10.3452 9.16675 10 9.16675H7.91667C7.57149 9.16675 7.29167 8.88693 7.29167 8.54175Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLeads);
export default __webpack_public_path__ + "static/media/TotalLeads.e9f3b92298f1a0789dff030edccdfc8e.svg";
export { ForwardRef as ReactComponent };